// extracted by mini-css-extract-plugin
export default {"host-image":"HostImage-module_host-image_AwW1z","hostImage":"HostImage-module_host-image_AwW1z"};